export function serializeProviderUserId(user) {
    return "".concat(user.provider, ":").concat(user.providerId);
}
